import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  MatButtonToggleChange,
  MatButtonToggleGroup,
} from '@angular/material/button-toggle';
import { MatDialog } from '@angular/material/dialog';
import { PermissionDialogComponent } from '../permission-dialog/permission-dialog.component';
import { PERMISSION_DIALOG_CONFIG } from '../permission-dialog/permission-dialog.constants';
import { SEGMENTED_SELECT_MAX_TOGGLE_OPTIONS } from './segmented-select.constants';
import {
  SegmentedSelectChange,
  SegmentedSelectOption,
} from './segmented-select.types';

@Component({
  selector: 'firebird-web-segmented-select',
  templateUrl: './segmented-select.component.html',
  styleUrls: ['./segmented-select.component.scss'],
  standalone: false,
})
export class SegmentedSelectComponent<V extends string = string> {
  @Input() options: SegmentedSelectOption<V>[] | null = [];
  @Input() value: V | null | undefined;
  @Input() disabled = false;
  @Input() maxToggleOptions = SEGMENTED_SELECT_MAX_TOGGLE_OPTIONS;
  @Input() dropdownClass = 'multi-dd-start widget-panel';
  @Input() dropdownWidth!: string;

  @Output() changeEvent = new EventEmitter<SegmentedSelectChange<V>>();

  @ViewChild(MatButtonToggleGroup)
  private readonly toggleGroup?: MatButtonToggleGroup;

  constructor(private readonly matDialog: MatDialog) {}

  public get isToggle(): boolean {
    return (this.options?.length ?? 0) <= this.maxToggleOptions;
  }

  public isLocked({ isPermitted }: SegmentedSelectOption<V>): boolean {
    return isPermitted === false;
  }

  // group (change) covers mouse and keyboard; keyboard selection fires no click
  public onToggleChange({ value }: MatButtonToggleChange): void {
    const option = this.options?.find((item) => item.value === value);
    if (!option) {
      return;
    }
    if (this.isLocked(option)) {
      // mat-button-toggle checks itself before emitting, so restore the real selection
      this.resetToggleSelection();
      this.matDialog.open(PermissionDialogComponent, PERMISSION_DIALOG_CONFIG);
      return;
    }
    if (option.value !== this.value) {
      this.changeEvent.emit({ value: option.value });
    }
  }

  public onDropdownChange({ value }: SegmentedSelectChange<V>): void {
    this.changeEvent.emit({ value });
  }

  private resetToggleSelection(): void {
    if (this.toggleGroup) {
      this.toggleGroup.value = this.value;
    }
  }
}
